import { useForm } from '@agrotoken-tech/ui';
import { useToastsHook, useTranslation } from '@bcba/react-hooks';
import { ExplorerUserProfileSerializer } from '@bcba/serializers';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { useMutation } from '@tanstack/react-query';
import { useUserContext } from '../../../contexts/UserContext';
import { putUserProfile } from '../../../services/users';
import { UpdateUserProfileDto } from '../../../services/users/dto';

const resolver = classValidatorResolver(UpdateUserProfileDto);

export const useUserProfile = () => {
  const { user } = useUserContext();
  const formId = 'update-user-profile-form';
  const { showSuccessToast } = useToastsHook();
  const { t } = useTranslation();

  const formMethods = useForm<ExplorerUserProfileSerializer>({
    resolver,
    defaultValues: user,
  });

  const { handleSubmit } = formMethods;

  const { mutate, isPending: isLoadingMutate } = useMutation({
    mutationFn: (dto: UpdateUserProfileDto) => putUserProfile(dto),
    onSuccess: () => {
      showSuccessToast({
        title: t('companyContactInformation.toast.success.title'),
      });
    },
  });

  const onSubmit = async (data: UpdateUserProfileDto) => {
    mutate({ phoneNumber: data.phoneNumber });
  };

  return {
    formId,
    user,
    formMethods,
    handleSubmit,
    onSubmit,
    isLoadingMutate,
  };
};

export default useUserProfile;
